// Daily Parameter constants
export const FETCH_DAILY_PARAMETER_DATES = 'FETCH_DAILY_PARAMETER_DATES';
export const FETCH_DAILY_PARAMETER_DATES_SUCCESS =
  'FETCH_DAILY_PARAMETER_DATES_SUCCESS';
export const FETCH_DAILY_PARAMETER_DATES_FAILURE =
  'FETCH_DAILY_PARAMETER_DATES_FAILURE';

// Daily Parameter Data
export const FETCH_DAILY_PARAMETER_DATA = 'FETCH_DAILY_PARAMETER_DATA';
export const FETCH_DAILY_PARAMETER_DATA_SUCCESS =
  'FETCH_DAILY_PARAMETER_DATA_SUCCESS';
export const FETCH_DAILY_PARAMETER_DATA_FAILURE =
  'FETCH_DAILY_PARAMETER_DATA_FAILURE';
export const CLEAR_SELECTED_DAILY_PARAMETER = 'CLEAR_SELECTED_DAILY_PARAMETER';

// Passive Parameter Data by Type
export const FETCH_PASSIVE_PARAMETER_DATA = 'FETCH_PASSIVE_PARAMETER_DATA';

// Legacy constants (for backward compatibility)
export const FETCH_AVERAGE_WALKING_SPEED = 'FETCH_AVERAGE_WALKING_SPEED';
